import React from 'react'
import {
    HashRouter as Router,
    Link
} from 'react-router-dom'

export default function sidebar(props) {
    return (
        <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
            <aside className="sidebar" style={{ top: 0 }}>
                <div className="sidebar-widget product-container">
                    <div className="product-side">
                        <h3>{props.name}</h3>

                        {props.data.productUrl && (
                            <div className="svg-container">
                                <img src={props.data.productUrl} alt={props.data.product} />
                            </div>
                        )}
                        <h3>{props.data.product}</h3>
                        {props.type === 'standard' ? (
                            <div className="product-side-container text-left">
                                <span className="s-d-a mr-4" >A-Maß: <strong>{props.data.da}</strong></span>
                                <span className="s-d-b mr-4" >B-Maß: <strong>{props.data.db}</strong></span>
                                <span className="s-d-c mr-4" >C-Maß: <strong>{props.data.dc}</strong></span>
                                <h5 className="mb-2 mt-2 s-cross-slope">Quergefälle: <strong>{props.data.crossSlope}</strong></h5>
                                <h5 className="mb-2 mt-2 s-running-meter">Laufende Meter: <strong>{props.data.runninMeter}</strong></h5>
                                <h5 className="mb-2 mt-2 s-cutting-length">Zuschnittlänge: <strong>{props.data.cuttingLength}</strong></h5>
                                <h5 className="mb-2 s-sheet-thickness">Blechstärke: <strong>{props.data.sheetThickness}</strong></h5>
                                <h5 className="mb-2 s-bracket-space">Halterabstand: <strong>{props.data.bracketSpace}</strong></h5>
                                <h5 className="mb-2 s-color">Beschichtung: <strong>{props.data.color}</strong></h5>
                            </div>
                        ) : props.type === "equipment" ? (
                            <div className="product-side-container text-left">
                                {props.data.url && (
                                    <div className="svg-container" >
                                        <img width="200" src={props.data.url} alt={props.data.selectedEq} />
                                    </div>
                                )}
                                <h3>{props.data.selectedEq}</h3>
                                {props.data.height!==0 && (<h5 className="mb-2 mt-2 s-cross-slope">Höhe der Aufkantung: <strong>{props.data.height}</strong></h5>)}
                                {props.data.panelSize!==0 && (<h5 className="mb-2 mt-2 s-cross-slope">Tafelmaß: <strong>{props.data.panelSize}</strong></h5>)}

                                {props.data.pieces!==0 && (<h5 className="mb-2 mt-2 s-cross-slope">Menge der Formteile: <strong>{props.data.pieces}</strong></h5>)}

                            </div>
                        ) : (<React.Fragment>

                            <div className="row text-center">
                                <div className="col-sm-12">
                                    <div className="form-group text-left">
                                        <label htmlFor="angle" className="card-title">Anzahl</label>
                                        <input className="form-control" type="number" name="angle" id="angle" />
                                    </div>

                                    <div className="form-group text-left">
                                        <label htmlFor="width" className="card-title">Breite</label>
                                        <input className="form-control" type="number" name="width" id="width" />
                                    </div>

                                    <div className="btn-group" role="group" aria-label="Basic example">
                                        <button className="btn btn-light" onClick={_=>props.deleteLine()}><i className="icon icon-trash la-trash-alt las"></i> Linie löschen</button>
                                        <button className="btn btn-primary" onClick={_=>props.drawLine()}><i className="icon icon-plus la-plus las"></i> Linie zeichnen</button>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>)}
                    </div>
                    <div className="sidebar-footer">
                        <Router>
                            <Link to="/" onClick={_=>props.resetEdit()} className="mr-5" style={{ color: "var(--dark)" }}>Abbrechen</Link>
                        </Router>
                        <button className="theme-btn btn-style-two small" onClick={e=>props.proxyClick(props.id)}><i className="las la-chevron-circle-right icon icon-arrow-right"></i> Speichern</button>
                    </div>
                </div>
            </aside>
        </div>
    )
}
